import api from "lib/api";

export const getAllRole = async (params = {}) => {
  return await api.post("/v1/rolePermission/getAllRole", params);
};

export const getDropdownRole = async (params = {}) => {
  return await api.post("/v1/dropdown/getAllRoleByCompanyId", params);
};

export const getDropdownRoleDefault = async (params = {}) => {
  return await api.post("/v1/dropdown/getRoleDefaultSet", params);
};

export const getRoleById = async (params = {}) => {
  return await api.post("/v1/rolePermission/getRoleById", params);
};

export const createRole = async (params = {}) => {
  return await api.post("/v1/rolePermission/createRole", params);
};

export const updateRole = async (params = {}) => {
  return await api.post("/v1/rolePermission/updateRole", params);
};

export const updatePermission = async (params = {}) => {
  return await api.post("/v1/rolePermission/updatePermission", params);
};

export const manageRoleStatus = async (params = {}) => {
  return await api.post("/v1/rolePermission/manageRoleStatus", params);
};

export const getPermissionAllRole = async (params = {}) => {
  return await api.post("/v1/rolePermission/getAllRole", params);
};

export const allowRolePermissionByRoleId = async (params = {}) => {
  return await api.post("/v1/dropdown/getAllowRolePermission", params);
};

export const updateAllowRolePermission = async (params = {}) => {
  return await api.post("/v1/rolePermission/updateAllowRolePermission", params);
};
